import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  ClipboardList,
  Users,
  Package,
  CreditCard,
  UserCog,
  BarChart3,
  Settings,
  Building2,
  Receipt,
  Wallet,
  BrainCircuit,
  ShieldCheck,
  FileText,
  LogOut,
} from 'lucide-react';

export interface NavItem {
  path: string;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export interface NavGroup {
  title?: string;
  items: NavItem[];
}

function getIcon(label: string) {
  const map: Record<string, React.ComponentType<{ className?: string }>> = {
    门店概览: LayoutDashboard,
    工单管理: ClipboardList,
    客户车辆: Users,
    库存配件: Package,
    收款流水: CreditCard,
    员工权限: UserCog,
    经营报表: BarChart3,
    门店设置: Settings,
    平台总览: LayoutDashboard,
    租户门店: Building2,
    套餐订阅: Receipt,
    支付订单: Wallet,
    'AI 工具额度': BrainCircuit,
    平台管理员: ShieldCheck,
    平台配置: Settings,
    操作日志: FileText,
    套餐订单: Receipt,
  };
  return map[label];
}

function NavItemLink({ item }: { item: NavItem }) {
  const Icon = item.icon ?? getIcon(item.label);
  return (
    <NavLink
      to={item.path}
      end={item.path === '/shop-admin/dashboard' || item.path === '/admin/dashboard'}
      className={({ isActive }) =>
        `group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${
          isActive
            ? 'bg-blue-50 text-blue-700'
            : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
        }`
      }
    >
      {Icon && <Icon className="h-4 w-4" />}
      <span>{item.label}</span>
    </NavLink>
  );
}

export function Sidebar({
  title,
  subtitle,
  groups,
  onLogout,
  footer,
}: {
  title: string;
  subtitle: string;
  groups: NavGroup[];
  onLogout?: () => void;
  footer?: React.ReactNode;
}) {
  return (
    <aside className="flex w-60 flex-col border-r border-gray-200 bg-white">
      <div className="p-6">
        <h1 className="text-xl font-bold tracking-tight text-gray-900">{title}</h1>
        <p className="mt-1 text-xs text-gray-500">{subtitle}</p>
      </div>

      <nav className="flex-1 space-y-6 overflow-y-auto px-4 pb-4">
        {groups.map((group, idx) => (
          <div key={idx}>
            {group.title && (
              <h3 className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                {group.title}
              </h3>
            )}
            <div className="space-y-1">
              {group.items.map((item) => (
                <NavItemLink key={item.path} item={item} />
              ))}
            </div>
          </div>
        ))}
      </nav>

      <div className="border-t border-gray-100 p-4">
        {footer}
        {onLogout && (
          <button
            type="button"
            onClick={onLogout}
            className="mt-2 flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900"
          >
            <LogOut className="h-4 w-4" />
            <span>退出登录</span>
          </button>
        )}
      </div>
    </aside>
  );
}
